module.exports = __webpack_public_path__ + "media/packs/images/flags/RS-f5089a6975ca11c8a4d6cf981891e49b.png";